import { ReactNode } from "react";
import AppButton from "./AppButton";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "tss-react/mui";

import { SX_FORM_CANCEL, SX_FORM_SUBMIT } from "../Configuration/styles";
import ResponsiveDialog from "./ResponsiveDialog";

const useStyles = makeStyles()((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      backgroundColor: theme.vars.palette.background.dialog,
    },
    // The buttons carry 24px outer margins (SX_*_BUTTON_FORM): dropping the
    // actions' own padding lines their edges up with the 24px content padding.
    "& .MuiDialogActions-root": {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

/**
 * Simple modal of confirmation
 *
 * @param isLoading
 * @param title
 * @param message
 * @param open
 * @param onClose
 * @param onSubmit
 */
const ConfirmationDialog = ({
  isLoading,
  message,
  title,
  open,
  onClose,
  onSubmit,
  children,
}: {
  isLoading: boolean;
  message: string;
  title: string;
  open: boolean;
  onClose: (value: boolean) => void;
  onSubmit: () => void;
  /** Extra content under the message — an option the confirmation itself carries,
   *  such as a checkbox that changes what the confirmed action does. */
  children?: ReactNode;
}) => {
  const { classes } = useStyles();

  return (
    <ResponsiveDialog
      classes={classes.root}
      crossIcon
      onClose={() => onClose(false)}
      open={open}
      fullWidth={true}
      title={title}
      actions={
        <>
          <AppButton
            intent="tonal"
            onClick={() => onClose(false)}
            sx={SX_FORM_CANCEL}
          >
            <FormattedMessage id="CANCEL" />
          </AppButton>
          <AppButton
            onClick={() => onSubmit()}
            type="submit"
            loading={isLoading}
            sx={SX_FORM_SUBMIT}
          >
            <span>
              <FormattedMessage id="SUBMIT" />
            </span>
          </AppButton>
        </>
      }
    >
      {message}
      {children}
    </ResponsiveDialog>
  );
};

export default ConfirmationDialog;
